<template>
  <div class="rc-file-div">
    <div class="rc-file-drag-div"
         ref="rcFileDragDiv"
         v-show="dragActive"
         @dragleave.prevent.stop="dragActive = false"
         @drop.stop.prevent="dragUploadFile">释放即可添加附件</div>
    <el-form-item @mouseenter.stop.native="controlMouseOver(component, index)"
                  @dragenter.native.prevent.stop="dragActive = true"
                  @click.native="controlClick(component, index)"
                  v-show="!dragActive"
                  :ref="component.id"
                  class="rc-file"
                  :class="getClassByCopy"
                  :prop="getProp"
                  :rules="rules"
                  :label-width="labelParameter.width">
      <div v-if="labelParameter.showSlot" :class="['control-label', labelParameter.className]" slot="label">{{labelParameter.labelName}}</div>
      <el-tooltip class="component-explain-tooltip" v-if="component.properties.componentExplain" :content="component.properties.componentExplain" placement="bottom-start">
        <span class="fa fa-question-circle"></span>
      </el-tooltip>
      <div :class="['rc-file-runtime', !validateType && 'error-rc-file']">
        <!--        <el-tooltip v-if="value || fileList.name" popper-class="file-tooltip file-dropdown-picture" transition="''" :visible-arrow="false" class="file-name" placement="bottom">-->
        <template v-if="fileLists.length >= 1 && component.properties.multiple === true">
          <el-dropdown v-if="fileLists.length" class="upload-file file-name" placement="bottom-start" :hide-on-click='false'>
            <span class="el-dropdown-link name" v-show="!dragActive">
          {{fileLists[0] && fileLists[0].name}}  ( {{ getUploadSuccessFileLength }} )<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu ref="uploadDropdownMenu"
                              class="rc-file-dropdown rc-file-dropdown-picture"
                              slot="dropdown"
                              v-if="fileLists.length >= 1">
              <vue-draggable v-model="fileLists" @update="updateFileOrder">
                <transition-group>
                  <el-dropdown-item v-for="item in fileLists" :key="item.url">
                    <a class="item" :title="item.name">{{ item.name }}</a>
                    <i v-if="disabled !== true"
                       class="el-icon-circle-close"
                       @click.stop="delFile(item, fileLists)"></i>
                    <div v-if="item.loading" class="progress"><el-progress color="#53A6E8" :stroke-width="3" :show-text="false" :percentage="getPercentage(item)"></el-progress></div>
                    <div class="preivew-or-down picture-upload">
                      <div class="preivew" @click.stop="previewFile(item)">
                        <i class="el-icon-view"></i><span>预览</span>
                      </div>
                      <div class="external-link-preview" v-if="hasNewWindow(item)" @click.stop="externalLinkPreview(item)">
                        <i></i><span>新窗口预览</span>
                      </div>
                      <div class="down" @click.stop="downFile(item)">
                        <i class="el-icon-download"></i><span>下载</span>
                      </div>
                      <div class="pack-down-all" @click.stop="packDown" v-show="fileLists.length > 1">
                        <i></i><span>打包下载</span>
                      </div>
                    </div>
                  </el-dropdown-item>
                </transition-group>
              </vue-draggable>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
        <template v-else-if="fileLists.length === 1 && !dragActive && component.properties.multiple !== true">
          <div v-if="fileLists[0].loading" class="progress"><el-progress color="#53A6E8" :stroke-width="3" :show-text="false" :percentage="getPercentage(fileLists[0])"></el-progress></div>
          <el-tooltip popper-class="file-tooltip file-dropdown-picture" transition="''" :visible-arrow="false" class="file-name" placement="bottom">
            <div class="title" slot="content">
              <div class="preivew" @click.stop="previewFile(fileLists[0])">
                <i class="el-icon-view"></i><span>预览</span>
              </div>
              <div class="external-link-preview" v-if="hasNewWindow(fileLists[0])" @click.stop="externalLinkPreview(fileLists[0])">
                <i></i><span>新窗口预览</span>
              </div>
              <div class="down" @click.stop="downFile(fileLists[0])">
                <i class="el-icon-download"></i><span>下载</span>
              </div>
            </div>
            <div class="upload-file" :title="fileLists[0].name">
              <span class="name" :title="fileLists[0].name">{{ fileLists[0].name }}</span>
            </div>
          </el-tooltip>
        </template>
        <!-- 文件没有上传的时候，左侧需要留一片空白。。。 -->
        <div v-else class="upload-file"></div>
        <el-upload
          action=""
          ref="uploadControl"
          class="avatar-uploader"
          :headers="headers"
          name="files"
          :multiple="component.properties.multiple"
          :auto-upload="!component.properties.multiple"
          :http-request="uploadFile"
          :before-upload="beforeUpload"
          :show-file-list="false"
          :on-error="uploadFailed"
          :disabled="disabled"
          :on-progress="fileProgress"
          :on-change = "fileChange"
          :data="{type: 'USER'}">
          <el-button class="upload-button" type="text">添加附件</el-button>
        </el-upload>
      </div>
      <!-- 文件上传提示 -->
      <el-dialog v-if="dialogParams.visable" class="rc-file-dialog" title="附件上传提示" :visible.sync="dialogParams.visable" width="398px" append-to-body center :close-on-click-modal="false" top="28vh">
        <div class="hint" v-html="dialogParams.hint"></div>
        <span slot="footer" class="dialog-footer">
        <div class="hint-button">
          <el-button @click="dialogParams.visable = false">确定</el-button>
        </div>
      </span>
      </el-dialog>
      <!--图片预览-->
      <PicturePreview ref="picturePreview" @closePreview="closePreview" :coverPicList="coverPicList" v-if="swiperFlag" :src="previewFileSrc"></PicturePreview>
    </el-form-item>
  </div>
</template>

<script>
import {componentMixin, inputMixin, ossMixin, uploadMixin} from './mixins'
import tokenStorage from '@/plugins/tokenStorage'
import PicturePreview from './picture-preview-swiper'
import VueDraggable from 'vuedraggable'
import basicAxios from 'axios'
import OSS from 'ali-oss'
import JSZip from 'jszip'
export default {
  name: 'rc-file',
  mixins: [componentMixin, inputMixin, ossMixin, uploadMixin],
  props: ['component', 'value', 'index', 'disabled', 'custParams', 'labelParameter', 'tableCtrlKey'],
  inject: ['initState', 'initCount'],
  data () {
    let maxSize = 50
    let symbolKey = String(Symbol(new Date().valueOf()))
    if (this.component.properties.fileSize) {
      maxSize = parseInt(this.component.properties.fileSize) <= 50 ? parseInt(this.component.properties.fileSize) : 50
    }
    maxSize = maxSize * 1024 * 1024
    return {
      fileList: [],
      headers: {
        'Authorization': tokenStorage.getToken()
      },
      name: '',
      enableEvent: false,
      uploading: false,
      file: null,
      // uploadUrl: `${process.env.UPLOAD_URL}/api/upload-file`,
      fileLists: [],
      // 校验状态
      validateType: true,
      maxSize: maxSize,
      timers: [],
      timeOut: null,
      dragTimer: null,
      dialogParams: {
        visable: false,
        hint: ''
      },
      selectFileList: {
        list: [],
        selected: []
      },
      isUpload: false,
      swiperFlag: false,
      coverPicList: [],
      previewFileSrc: '',
      sortFileLists: [],
      symbolKey
    }
  },
  components: {
    PicturePreview,
    VueDraggable
  },
  watch: {
    'initState.state' (val) {
      if (val) {
        this.initFileList()
      }
    },
    'initCount.value' (val) {
      if (val > 0) {
        this.$set(this, 'fileList', [])
        this.$set(this, 'fileLists', [])
      }
    },
    'fileLists.length' (val) {
      if (val > 1) {
        // 预览的时候不要自动展开
        this.$nextTick(() => !this.swiperFlag && this.isUpload && this.$refs && this.$refs.uploadDropdownMenu && this.$refs.uploadDropdownMenu.dropdown && this.$refs.uploadDropdownMenu.dropdown.show())
      }
    },
    // 'value' (val) {
    //   if (val) {
    //     this.name = this.value.split(',')[0]
    //     this.$set(this, 'fileList', {name: this.value.split(',')[0], url: this.value.slice(this.value.indexOf(',') + 1), loading: false, file: null})
    //   } else {
    //     // 删除之后不赋值回导致显示bug 这个name form-runtime还有用、
    //     this.name = ''
    //     this.$set(this, 'fileList', {})
    //   }
    // }
    value (val) {
      if (val) {
        let fileArray = val.split('$.$')
        let newFileList = []
        fileArray.forEach(m => {
          if (m) {
            let name = m.split(',/')[0]
            // 如果是关联的图片类型的控件, 过滤掉所有非图片文件
            newFileList.push({name: name, url: m.slice(m.indexOf(',/') + 1)})
          }
        })
        this.fileLists = newFileList
      }
    }
  },
  created () {
    window.addEventListener('beforeunload', this.removeSymbolKey, false)
    window.addEventListener('load', this.removeSymbolKey, false)
  },
  mounted () {
    // 上传控件允许拖入事件
    this.initDragEvent(this.component.id)
    this.initDragEvent('rcFileDragDiv')
    let value
    if (this.value) {
      if (this.value.indexOf('$.$') !== 0) {
        value = '$.$' + this.value
      } else {
        value = this.value
      }
      let list = value.split('$.$').filter(item => item.trim() !== '')
      list.forEach(n => {
        if (n && n !== 'undefined') {
          this.fileLists.push({name: n.split(',/')[0], url: '/' + n.split(',/')[1]})
        }
      })
    }
    this.rules.push({
      validator: (rule, value, callback) => {
        if (this.uploading) {
          callback(new Error('文件上传中，请稍候'))
        } else {
          callback()
        }
      }
    })
  },
  methods: {
    uploadFile (files) {
      let file = files.file
      let key = this.getOssKey('USER', file.name)
      if (files.file.size > 104857600) {
        this.$axios.get('/shared-api/files/oss/sts').then(res => {
          const bucketEnvironment = sessionStorage.getItem('ossDownloadUrl').indexOf('ywdev') === -1 ? 'ywprod' : 'ywdev'
          let ossConfig = {
            region: 'oss-cn-hangzhou', // 根据那你的Bucket地点来填写
            accessKeyId: res.data.accessKeyId, // 自己账户的accessKeyId
            accessKeySecret: res.data.accessKeySecret, // 自己账户的accessKeySecret
            stsToken: res.data.securityToken,
            bucket: bucketEnvironment, // bucket名字
            secure: true
          }
          this.multipartUpload(files, ossConfig, key, null)
        })
      } else {
        this.fileProgress(file)
        let url = sessionStorage.getItem('ossDownloadUrl')
        let formData = this.getUploadFormData(key, file)
        let fileItem = this.sortFileLists.find(f => f.file === file)
        this.$axios.post(url, formData, {
          headers: {'Content-Type': 'multipart/form-data'},
          cancelToken: new basicAxios.CancelToken(c => {
            if (fileItem) {
              fileItem.cancel = c
            }
          })
        }).then(res => {
          res.status === 200 ? this.updateFile(this.getResult(key, file.name), file) : this.uploadFailed('', file)
        })
      }
    },
    async multipartUpload (files, config, key, checkpoint) {
      let client = new OSS(config)
      let file = files.file
      try {
        this.fileProgress(file)
        await client.multipartUpload('/' + key, files.file, {
          progress: (p, cpt) => {
            checkpoint = cpt
          },
          checkpoint: checkpoint
        })
        this.updateFile(this.getResult(key, file.name), file)
      } catch (e) {
        const _this = this
        if (e.name === 'SecurityTokenExpiredError') {
          _this.$axios.get('/shared-api/files/oss/sts').then(res => {
            const bucketEnvironment = sessionStorage.getItem('ossDownloadUrl').indexOf('ywdev') === -1 ? 'ywprod' : 'ywdev'
            let ossConfig = {
              region: 'oss-cn-hangzhou', // 根据那你的Bucket地点来填写
              accessKeyId: res.data.accessKeyId, // 自己账户的accessKeyId
              accessKeySecret: res.data.accessKeySecret, // 自己账户的accessKeySecret
              stsToken: res.data.securityToken,
              bucket: bucketEnvironment, // bucket名字
              secure: true
            }
            _this.multipartUpload(files, ossConfig, key, checkpoint)
          })
        } else if (e.name === 'ConnectionTimeoutError') {
          await _this.multipartUpload(files, config, key, checkpoint)
        } else {
          window.addEventListener('online', async function reLoad () {
            try {
              let file = files.file
              await client.multipartUpload('/' + key, files.file, {
                progress: (p, cpt) => {
                  checkpoint = cpt
                },
                checkpoint: checkpoint
              })
              _this.updateFile(_this.getResult(key, file.name), file)
              window.removeEventListener('online', reLoad)
            } catch (e) {
              const __this = _this
              if (e.name === 'SecurityTokenExpiredError') {
                window.removeEventListener('online', reLoad)
                __this.$axios.get('/shared-api/files/oss/sts').then(res => {
                  const bucketEnvironment = sessionStorage.getItem('ossDownloadUrl').indexOf('ywdev') === -1 ? 'ywprod' : 'ywdev'
                  let ossConfig = {
                    region: 'oss-cn-hangzhou', // 根据那你的Bucket地点来填写
                    accessKeyId: res.data.accessKeyId, // 自己账户的accessKeyId
                    accessKeySecret: res.data.accessKeySecret, // 自己账户的accessKeySecret
                    stsToken: res.data.securityToken,
                    bucket: bucketEnvironment, // bucket名字
                    secure: true
                  }
                  __this.multipartUpload(files, ossConfig, key, checkpoint)
                })
              } else if (e.name === 'ConnectionTimeoutError') {
                await _this.multipartUpload(files, config, key, checkpoint)
              }
            }
          })
        }
      }
    },
    initFileList () {
      this.fileLists = []
      let value
      if (this.value) {
        if (this.value.indexOf('$.$') !== 0) {
          value = '$.$' + this.value
        } else {
          value = this.value
        }
        let list = value.split('$.$').filter(item => item.trim() !== '')
        list.forEach(n => {
          if (n && n !== 'undefined') {
            this.fileLists.push({name: n.split(',/')[0], url: '/' + n.split(',/')[1]})
          }
        })
      }
    },
    fileChange (file, fileList) {
      if (file && file.status === 'ready') {
        let self = this
        if (self.component.properties.multiple) {
          if (self.timeOut) {
            clearTimeout(self.timeOut)
          }
          this.timeOut = setTimeout(() => {
            let list = fileList.filter(f => f.size >= self.maxSize)
            if (list && list.length > 0) {
              if (fileList.filter(f => f && f.status === 'ready').length === 1) {
                let hint = `您选择的文件不能上传，原因如下:<br><span title="${file.name}" class="file-name">${file.name}</span><span style="color: red">(超过${this.component.properties.fileSize || 50}M限制)</span>`
                this.openDialog({visable: true, width: '398px', type: 'hint', hint})
              } else {
                this.selectFileList.list = fileList
                let fl = this.$_.cloneDeep(fileList)
                // 加上是否勾选标识
                fl.forEach(f => { f.checked = f.size < self.maxSize })
                this.selectFileList.selected = fl
                this.openDialog({visable: true, width: '430px', type: 'select'})
              }
            } else {
              self.$refs.uploadControl.submit()
              // submit 之后清空 文件列表
              self.$refs.uploadControl.clearFiles()
            }
          }, 10)
        }
      }
    },
    beforeUpload (file) {
      if (!this.isUpload) {
        this.isUpload = true
      }
      if (this.component.properties.multiple === false) {
        // 单文件上传，如果有文件正在上传，需要取消正在上传的文件
        let findFile = this.fileLists.find(f => f.loading)
        findFile && this.$refs.uploadControl.abort(findFile.file)
        this.fileLists = []
        if (file.size >= this.maxSize) {
          let hint = `您选择的文件不能上传，原因如下:<br><span title="${file.name}" class="file-name">${file.name}</span><span style="color: red">(超过${this.component.properties.fileSize || 50}M限制)</span>`
          this.openDialog({visable: true, width: '398px', type: 'hint', hint})
          return false
        }
      }
      let type = file.name.split('.').pop()
      if (this.component.properties.allowFileType && this.component.properties.allowFileType.length !== 0) {
        // 文件选择控件和表格内的文件选择 如果设置了上传文件的允许类型,则判断
        if (!this.component.properties.allowFileType.some(n => n === type.toLowerCase())) {
          this.$message.warning(`只能上传${this.component.properties.allowFileType.join()}格式的文件`)
          return false
        }
      }
      this.uploading = true
      this.fileLists.push({name: file.name, url: file.uid, loading: true, file, progress: 0})
      this.sortFileLists.push({file})
    },
    // initComponent () {
    //   this.enableEvent = true
    // },
    // handleAvatarSuccess (res) {
    //   this.uploading = false
    //   // 上传成功
    //   let name = res[0].result.file
    //   let dir = res[0].result.dir
    //   this.update(`${name},${dir}`)
    //   this.$nextTick(() => {
    //     this.validateType = true
    //     // 触发值改变事件
    //     this.executeFunctions('change')
    //   })
    // },
    uploadFailed (err, file, fileList) {
      let i = this.fileLists.findIndex(f => f.url === file.uid)
      i !== -1 && this.fileLists.splice(i, 1)
      this.uploading = false
      this.$refs[this.component.id].validate()
      this.$message.error(`${file.name} 上传失败，请重新上传`)
      throw new Error(err)
    },
    updateFile (res, file, fileList) {
      let findFile = this.fileLists.find(f => f.loading && (f.url === file.uid || f.dragFile))
      this.uploading = false
      this.$refs[this.component.id].validate()
      let name = res[0].result.file
      let url = res[0].result.dir
      if (findFile) {
        let time = this.timers.find(t => t.id === findFile.url)
        time && clearInterval(time)
        findFile.progress = 100
        findFile.url = res[0].result.dir
        findFile.loading = false
      }
      //  清空文件
      this.$refs.uploadControl.clearFiles()
      // 更新归档这个一定要放在方法的最后, 否则会被下面value的监听影响
      if (this.component.properties.multiple === false) {
        this.update(`${''}$.$${name},${url}`)
      } else {
        let value_
        if (this.value) {
          if (this.value.indexOf('$.$') !== 0) {
            value_ = '$.$' + this.value
          } else {
            value_ = this.value
          }
        }
        let fileLists = `${value_ || ''}$.$${name},${url}`.split('$.$').slice(1)
        fileLists.sort((a, b) => {
          return (a.charCodeAt(0) - b.charCodeAt(0))
        })
        let value = '$.$' + fileLists.join('$.$')
        this.update(value)
      }
      // 触发值改变事件
      this.$nextTick(() => this.executeFunctions('change'))
    },
    updateFileOrder () {
      let value = ''
      this.fileLists.forEach(f => {
        value += `$.$${f.name},${f.url}`
      })
      this.update(value)
    },
    getDownLoadUrl (path) {
      //  return path.includes('USER') ? sessionStorage.getItem('downloadUrl') : sessionStorage.getItem('cdnDownloadUrl')
      return sessionStorage.getItem('ossDownloadUrl')
    },
    getFile (file) {
      let url = ''
      if (file.url.includes('http')) {
        url = file.url
      } else {
        url = `${location.origin}/shared-api/files/download?data=${encodeURIComponent('$.$')}${encodeURIComponent(file.name)},${file.url}`
      }
      return this.$axios.get(url, {responseType: 'blob'})
    },
    downFile (file) {
      if (file.loading) {
        return this.$message.info('该文件正在上传中，请上传完成后再试')
      } else {
        this.getFile(file).then(res => {
          const url = window.URL.createObjectURL(res.data)
          const a = document.createElement('a')
          a.href = url
          a.download = file.name
          a.click()
          window.URL.revokeObjectURL(url)
        })
      }
    },
    delFile (file, fileList) {
      // eslint-disable-next-line eqeqeq
      let findIndex = this.sortFileLists.findIndex(f => f.file.uid == file.url)
      findIndex !== -1 && this.sortFileLists[findIndex].cancel && this.sortFileLists[findIndex].cancel()
      this.sortFileLists.splice(findIndex, 1)
      // 删除前取消上传状态
      this.uploading = false
      this.$refs[this.component.id].validate()
      // eslint-disable-next-line eqeqeq
      let index = fileList.findIndex(item => item.url === file.url || (item.file && item.file.uid == file.url))
      if (this.value) {
        let value_
        if (this.value.indexOf('$.$') !== 0) {
          value_ = '$.$' + this.value
        } else {
          value_ = this.value
        }
        let list = value_.split('$.$')
        list.splice(index + 1, 1)
        this.update(list.join('$.$'))
        // 触发值改变事件
        this.$nextTick(() => this.executeFunctions('change'))
      }
      index !== -1 && this.fileLists.splice(index, 1)
    },
    async previewFile (file) {
      if (file.loading) {
        return this.$message.info('该文件正在上传中，请上传完成后再试')
      } else {
        // 点击预览 关闭列表
        this.$refs && this.$refs.uploadDropdownMenu && this.$refs.uploadDropdownMenu.dropdown && this.$refs.uploadDropdownMenu.dropdown.hide()
        let src = file.url
        // 非 doc、docx、xls、xlsx 走 view 接口
        let types = src.split('.')
        let type = types[types.length - 1].toLowerCase()
        if (['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'].includes(type)) {
          let href = this.$router.resolve({name: 'filePreview', query: {src, name: file.name}}).href
          window.open(href, '_blank')
        } else if (['png', 'jpg', 'jpeg', 'gif', 'pdf', 'txt'].includes(type)) {
          try {
            await this.eventBus.$emit('form.previewPicture', ({component: this.component, src: file.url, fileLists: this.fileLists}))
          } catch (e) {
            console.log(e)
            return null
          }
          // pdf 与 txt 在ali oss文件系统上可以直接预览
          if (['pdf', 'txt'].includes(type)) {
            src.includes('http') ? window.open(src) : window.open(`${sessionStorage.getItem('ossDownloadUrl')}${src}`)
          } else {
            //  55th:所有租户用新预览
            this.redCatPreviewPic(src)
            // let href = this.$router.resolve({name: 'imagePreview', query: {src: sessionStorage.getItem('ossDownloadUrl') + src, name: file.name}}).href
            // window.open(href, '_blank')
          }
        } else if (type === 'ofd') {
          const ossDownloadUrl = sessionStorage.getItem('ossDownloadUrl')
          this.$axios.get(`/shared-api/files/ofdConvertPdf?url=${ossDownloadUrl}${src}`).then(res => {
            window.open(`${ossDownloadUrl}${res.data}`)
          })
        } else {
          this.$message.info('暂不支持该类型文件预览')
        }
      }
    },
    // remove () {
    //   this.update('')
    //   // 触发值改变事件
    //   this.$nextTick(() => this.executeFunctions('change'))
    // },
    async externalLinkPreview (file) {
      if (file.loading) {
        return this.$message.info('该文件正在上传中，请上传完成后再试')
      } else {
        // 点击预览 关闭列表
        this.$refs && this.$refs.uploadDropdownMenu && this.$refs.uploadDropdownMenu.dropdown && this.$refs.uploadDropdownMenu.dropdown.hide()
        let src = file.url
        // 非 doc、docx、xls、xlsx 走 view 接口
        let types = src.split('.')
        let type = types[types.length - 1].toLowerCase()
        if (['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'].includes(type)) {
          let href = this.$router.resolve({name: 'filePreview', query: {src, name: file.name}}).href
          window.open(href, '_blank')
        } else if (['png', 'jpg', 'jpeg', 'gif', 'pdf', 'txt'].includes(type)) {
          try {
            await this.eventBus.$emit('form.previewPicture', ({component: this.component, src: file.url, fileLists: this.fileLists}))
          } catch (e) {
            console.log(e)
            return null
          }
          // pdf 与 txt 在ali oss文件系统上可以直接预览
          if (['pdf', 'txt'].includes(type)) {
            src.includes('http') ? window.open(src) : window.open(`${sessionStorage.getItem('ossDownloadUrl')}${src}`)
          } else {
            let imageType = ['png', 'jpg', 'jpeg', 'gif']
            let fileList = this.fileLists.filter(f => !f.loading && imageType.includes(f.url.split('.').pop().toLowerCase()))
            // 过滤掉正在上传的其他文件，和非图片控件
            sessionStorage.setItem(this.symbolKey, JSON.stringify(fileList))
            let href = this.$router.resolve({name: 'imagePreview', query: {id: this.symbolKey, src}}).href
            window.open(href, '_blank')
          }
        } else if (type === 'ofd') {
          const ossDownloadUrl = sessionStorage.getItem('ossDownloadUrl')
          this.$axios.get(`/shared-api/files/ofdConvertPdf?url=${ossDownloadUrl}${src}`).then(res => {
            window.open(`${ossDownloadUrl}${res.data}`)
          })
        } else {
          this.$message.info('暂不支持该类型文件预览')
        }
      }
    },
    packDown () {
      let fileName = this.component.properties.listType === 'picture' ? '下载的图片.zip' : '下载的文件.zip'
      let zip = new JSZip()
      let getFilePromiseArray = this.fileLists.map(file => {
        return this.getFile(file).then(res => {
          zip.file(file.name, res.data, {binary: true})
        })
      })
      return Promise.all(getFilePromiseArray).then(() => {
        zip.generateAsync({
          type: 'blob'
        }).then(content => {
          const url = window.URL.createObjectURL(content)
          const a = document.createElement('a')
          a.href = url
          a.download = fileName
          a.click()
          window.URL.revokeObjectURL(url)
        })
      })
      // let data = {data: this.value}
      // this.$axios({
      //   method: 'post',
      //   url: '/shared-api/files/downloadZip',
      //   responseType: 'blob',
      //   data
      // }).then(res => {
      //   let blob = new Blob([res.data], { type: 'application/zip' })
      //   let url = window.URL.createObjectURL(blob)
      //   let vDom = document.createElement('a')
      //   vDom.style.display = 'none'
      //   vDom.href = url
      //   vDom.setAttribute('download', fileName)
      //   document.body.appendChild(vDom)
      //   vDom.click()
      //   document.body.removeChild(vDom)
      //   window.URL.revokeObjectURL(url)
      // })
    },
    redCatPreviewPic (src) {
      let allowType = ['png', 'jpg', 'jpeg', 'gif']
      this.coverPicList = this.fileLists.filter((c, index) => {
        let type = c.name.split('.').pop()
        return !c.loading && allowType.some(n => n === type.toLocaleLowerCase())
      })
      this.previewFileSrc = src
      this.$nextTick(() => {
        this.swiperFlag = true
      })
    },
    fileProgress (file) {
      if (file) {
        // 拖动上传的没有该属性
        if (!file.uid) {
          // 拖拽上传的以size的值作为标志
          this.fileLists.push({name: file.name, url: file.size, loading: true, file, progress: 0, dragFile: true})
        }
        // 文件正在上传，假进度条 上传网速按平均400kb算
        let item = this.fileLists.find(f => f.url === file.uid || f.url === file.size)
        if (!this.timers.find(t => t.id === item.url)) {
          // 文件大小/b / 400kb * 1024的网速 / 100每秒要长的进度条 * 1000 转毫秒
          let step = file.size / (400 * 1024) / 100 * 1000
          let timer = setInterval(() => item.progress++ >= 98 && clearInterval(timer), step)
          item && this.timers.push({id: item.url, timer})
        }
      }
    },
    openDialog (params) {
      this.$nextTick(() => {
        this.dialogParams = {...params}
      })
    },
    async save () {
      this.dialogParams.visable = false
      // 需要删除没有勾选的文件
      await this.deleteFile('checked')
      this.$nextTick(() => this.$refs.uploadControl.submit())
    },
    cancel () {
      this.$refs.uploadControl.clearFiles()
      this.dialogParams.visable = false
      if (this.component.properties.multiple) {
        // 取消的时候，需要把ready状态的文件删除
        this.deleteFile('ready')
      }
    },
    deleteFile (status) {
      let index
      if (status === 'ready') {
        index = this.selectFileList.list.findIndex(f => f && f.status === 'ready')
      } else {
        index = this.selectFileList.selected.findIndex(f => !f.checked)
      }
      if (index !== -1) {
        this.selectFileList.list.splice(index, 1)
        this.selectFileList.selected.splice(index, 1)
        this.deleteFile(status)
      }
    },
    closePreview () {
      this.swiperFlag = false
    },
    removeSymbolKey () {
      this.symbolKey && sessionStorage.removeItem(this.symbolKey)
    },
    customValidate () {
      this.validateType = !this.$refs[this.component.id].$el.classList.toString().includes('is-error')
    },
    abortRequest () {
      // 取消正在上传的文件
      if (this.fileList.loading && this.fileList.file) {
        this.$refs.uploadControl.abort(this.fileList.file)
        this.timer && clearInterval(this.timer)
      }
    },
    // 因为表格删除，如果正在上传的文件 value 是空的不会触发监听。。所以需要手动调用这个方法清空 fileList，要不然会导致渲染bug
    beforeDelete () {
      this.abortRequest()
      this.$nextTick(() => this.$set(this, 'fileLists', []))
    }
  },
  beforeDestroy () {
    this.destroyDragEvent(this.component.id)
    this.destroyDragEvent('rcFileDragDiv')
    this.beforeDelete()
    this.removeSymbolKey()
    this.timers = null
    let findFiles = this.fileLists.filter(f => f.loading)
    findFiles.length > 0 && findFiles.forEach(f => this.$refs.uploadControl.abort(f.file))
    window.removeEventListener('beforeunload', this.removeSymbolKey)
    window.removeEventListener('load', this.removeSymbolKey)
  },
  computed: {
    hasNewWindow () {
      return file => {
        let allowType = ['png', 'jpg', 'jpeg', 'gif']
        let type = file.name.split('.').pop()
        return allowType.some(n => n === type.toLocaleLowerCase())
      }
    },
    getUploadSuccessFileLength () {
      return this.fileLists.filter(c => !c.loading).length
    },
    // 文件过小的时候，定时还没走完，文件已经上传完成，会导致进度冒了。。
    getPercentage () {
      return item => {
        if (item.progress >= 100) {
          item.progress = 100
          return 100
        } else {
          return item.progress
        }
      }
    },
    getFileList () {
      return this.selectFileList.selected.filter(f => f && f.status === 'ready') || []
    },
    getFileSize () {
      return size => {
        if (size < (1024 * 1024)) {
          return `${Math.floor((size / 1024) * 100) / 100}K`
        } else {
          return `${Math.floor((size / 1024 / 1024) * 100) / 100}M`
        }
      }
    },
    getSelectSize () {
      return this.getFileList.length ? this.getFileList.map(f => f.checked ? f.size : 0).reduce((x, y) => x + y) / 1024 / 1024 : 0
    },
    getNoUploadFile () {
      return this.getFileList.length ? this.getFileList.filter(f => f.size >= this.maxSize).length : 0
    }
  }
}
</script>

<style lang="scss">
  .rc-file-div{
    width: 100%;
    height: 100%;
  }
  .rc-file {
    .rc-file-runtime {
      border: 1px solid #C2C3C4;
      border-radius: 4px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 28px;
      line-height: 28px;
      padding: 0 5px;
      background-color: #fff;
      .el-tooltip{
        font-size: 12px;
        color: #2a2929;
      }
      .el-dropdown{
        font-size: 12px;
        color: #2a2929;
      }
      .avatar-uploader {
        width: 52px;
        font-size: 12px;
        height: 100%;
        line-height: 26px;
        .el-upload {
          position: relative;
          width: 100%;
          border: none;
          height: 100%;
          margin-top: -1px;
          a.download {
            position: absolute;
            top: 50%;
            right: 5px;
            margin-top: -7px;
            text-decoration: underline;
          }
          .upload-button {
            font-size: 12px;
            padding: 0;
            & > span {
              text-decoration: underline;
              font-size: 12px;
            }
          }
          .upload-button.rc-file-button-drag{
            & > span {
              text-decoration: none;
            }
          }
        }
      }
      .upload-file {
        width: calc(100% - 55px);
        height: 28px;
        font-size: 12px;
        color: #2A2929;
        position: relative;
        margin: 0;
        & > .name {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          display: inline-block;
          width: 100%;
          font-size: 12px;
        }
        .progress {
          height: 5px;
          position: absolute;
          top: 22px;
          width: 100%;
        }
        &:hover {
          .name {
            color: #2A2929;
          }
        }
      }
      &:hover {
        .preivew-or-down {
          display: block;
        }
      }
      .preivew-or-down {
        position: absolute;
        color: #fff;
        width: 80px;
        background: rgba(0, 0, 0, .72);
        border-radius: 4px;
        line-height: 60px;
        z-index: 9999;
        left: 70px;
        top: 25px;
        display: none;

        .icon {
          cursor: pointer;
        }
        i.el-icon-view {
          margin-right: 5px;
        }
        .preivew, .down {
          height: 30px;
          line-height: 30px;
          text-align: center;
          &:hover{
            color: #4592E4;
          }
        }
      }
      .picture-upload {
        width: 98px;
        padding-left: 4px;

        .down, .preivew, > div {
          height: 21px;
          line-height: 21px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          i {
            font-size: 12px;
            margin-right: 5px;
          }

          span {
            font-size: 12px;
            display: inline-block;
            width: calc(100% - 10px);
            text-align: left;
          }
        }
      }
    }
    .error-rc-file {
      border-color: #F56C6C;
    }
  }
  .rc-file-drag-div{
    width: 100%;
    height: 100%;
    line-height: 40px;
    text-align: center;
    color: #53A6E8;
    border: 1px dashed #55ACF1;
    background-color: #F4F5F5;
    font-size: 12px;
  }
  .rc-file-dialog {
    .el-dialog {
      .el-dialog__body {
        padding: 15px 15px;
        & > .hint {
          padding: 15px 33px;
          line-height: 20px;
          .file-name {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: inline-block;
            max-width: 200px;
            vertical-align: bottom;
          }
        }
      }
      .el-dialog__footer {
        padding-top: 0;
        .dialog-footer {
          .hint-button {
            .el-button {
              width: 104px;
              height: 30px;
              border: 1px solid rgba( 84, 171, 241, 1);
              border-radius: 4px;
              padding: 0;
              color: #54ABF1;
            }
          }
        }
      }
    }
  }
  .el-tooltip__popper.file-dropdown-picture {
    width: 98px;
    > .title {
      width: 98px;
      padding-left: 4px;
      .down, .preivew, > div {
        height: 21px;
        line-height: 21px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        &:hover{
          color: #4592E4;
        }
        i {
          font-size: 12px;
          margin-right: 5px;
        }
        span {
          font-size: 12px;
          display: inline-block;
          width: calc(100% - 10px);
          text-align: left;
        }
      }
      .pack-down-all {
        &:hover{
          color: #4592E4;
          >i{
            filter: invert(50%) sepia(94%) saturate(1170%) hue-rotate(188deg) brightness(93%) contrast(92%);
          }
        }
        > i {
          display: inline-block;
          width: 12px;
          height: 12px;
          background: url("../../../form/runtime/components/assets/pack-download.png") no-repeat center;
        }
      }
      .external-link-preview {
        &:hover{
          color: #4592E4;
          >i{
            filter: invert(50%) sepia(94%) saturate(1170%) hue-rotate(188deg) brightness(93%) contrast(92%);
          }
        }
        > i {
          display: inline-block;
          width: 12px;
          height: 12px;
          background: url("../../../form/runtime/components/assets/link.png") no-repeat center;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/runtime/components/rc-file.vue